import React, {useRef, useState} from 'react'
import {Dropdown, InputDefault} from '../../../../components/ui'
import {FieldArray, FormikProvider, useFormik} from 'formik'
import {useQuery} from 'react-query'
import {getListRewardsNotValue0} from '../../../../modules/services/rewards.service'
import {Link} from 'react-router-dom'
import {
  getDepartment,
  getListProducts,
  getcustomerState,
} from '../../../../modules/services/product.service'

interface Props {
  handleChange: (e: any) => void
  id?: string
  initLoad?: any
  loadings?: any
}

const FormDepartment: React.FC<Props> = ({handleChange, id, initLoad, loadings}) => {
  const resetForms = useRef<any>(null)

  const initValue = {
    name: '',
    annual_budget: 0,
    kpi_redemption: 0,
    spending: 0,
    point_conversation: 0,
    description: '',
  }

  const formik = useFormik({
    initialValues: id ? initLoad : initValue,
    onSubmit: (values, {resetForm}) => {
      handleChange(values)
    },
    enableReinitialize: true,
  })
  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit} ref={resetForms}>
        <div className='d-flex flex-column align-items-center gap-4 px-8'>
          <div className='w-100'>
            <label htmlFor='name' className='form-label'>
              Department Name
            </label>
            <InputDefault
              type='text'
              id='name'
              name='name'
              value={formik.values.name}
              onChange={formik.handleChange}
            />
          </div>
          <div className='w-100'>
            <label htmlFor='annual_budget' className='form-label'>
              Annual Budget
            </label>
            <InputDefault
              type='number'
              id='annual_budget'
              name='annual_budget'
              value={formik.values.annual_budget}
              onChange={formik.handleChange}
            />
          </div>
          <div className='w-100'>
            <label htmlFor='kpi_redemption' className='form-label'>
              KPI Redemption
            </label>
            <div className='d-flex flex-row gap-4 align-items-center'>
              <InputDefault
                type='number'
                id='kpi_redemption'
                name='kpi_redemption'
                value={formik.values.kpi_redemption}
                onChange={formik.handleChange}
              />
              <span className=''>%</span>
            </div>
          </div>
          <div className='w-100'>
            <label htmlFor='description' className='form-label'>
              Description
            </label>
            <textarea
              className='form-control form-control mb-3'
              rows={3}
              data-kt-element='input'
              placeholder='Type a description'
              name='description'
              value={formik.values.description}
              onChange={formik.handleChange}
              //   onKeyDown={onEnterPress}
            ></textarea>
          </div>
          <div className='w-100'>
            <label htmlFor='spending' className='form-label'>
              Point Conversion Incetive
            </label>
            <div className='d-flex flex-row gap-4 align-items-center'>
              <span className=''>Spending</span>
              <InputDefault
                type='number'
                id='spending'
                name='spending'
                value={formik.values.spending}
                onChange={formik.handleChange}
              />
              <span>Point Conversion</span>
              <InputDefault
                type='number'
                id='point_conversation'
                name='point_conversation'
                value={formik.values.point_conversation}
                onChange={formik.handleChange}
              />
            </div>
          </div>
        </div>
        <div className=' d-flex justify-content-end py-6 px-9'>
          {!loadings ? (
            <button className='btn btn-primary' data-bs-target='#add-edit-member' type='submit'>
              Submit
            </button>
          ) : (
            <button className='btn btn-primary' data-kt-indicator='on' type='button'>
              <span className='indicator-progress'>
                Please wait...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            </button>
          )}
        </div>
      </form>
    </FormikProvider>
  )
}

export default FormDepartment
